import { computed, ref } from '@vue/composition-api'
import { mergeRawData } from '../utils/rawData'

export default function useChartData({ getDataPoint }) {
  const rawData = ref({})
  const currentTimeIndex = ref(0)
  const currentData = ref({})

  const setRawData = (data, resetData) => {
    if (!data) return
    rawData.value = mergeRawData(rawData.value, data, resetData)
  }

  const currentDataPoint = computed(() => getDataPoint(currentData.value, currentTimeIndex.value))
  const prevDataPoint = computed(() => getDataPoint(currentData.value, currentTimeIndex.value - 1))

  return {
    rawData, currentTimeIndex, currentData, setRawData, currentDataPoint, prevDataPoint,
  }
}
